import type { IRootState } from 'store/types';

import { selectors } from './adapter';

export const selectToasts = (state: IRootState) => selectors.selectAll(state);
